import React from 'react';
import { Badge as MUIBadge, createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) =>
  createStyles({
    badge: {
      cursor: ({ clickable }) => (clickable ? 'pointer' : 'auto'),
      '& .MuiBadge-badge': {
        backgroundColor: ({ color }) => color || theme.palette.orange.color,
        color: 'white',
        '&:hover': {
          backgroundColor: ({ clickable, color, hoverColor }) =>
            clickable ? hoverColor || theme.palette.orange.hoverColor : color,
        },
      },
    },
  })
);

export const Badge = ({ color, hoverColor, className, onClick, ...other }) => {
  const classes = useStyles({ color, hoverColor, clickable: !!onClick });

  return <MUIBadge {...other} className={clsx(classes.badge, className)} onClick={onClick} />;
};
